import { z } from 'zod';

/** Competencia mensal usada como chave unica do balancete salvo. */
export const competenciaBalanco = z
  .string()
  .regex(/^\d{4}-(0[1-9]|1[0-2])$/, 'Competencia invalida.');

export const contaBalanco = z.object({
  codigo: z.string().trim().min(1).max(64),
  nivel: z.number().int().min(1).max(20),
  reduzida: z.string().trim().max(64),
  desc: z.string().trim().max(1000),
  anterior: z.number().finite(),
  debito: z.number().finite(),
  credito: z.number().finite(),
  saldo: z.number().finite(),
  natureza: z.string().trim().max(1),
});

export const salvarBalancoRequest = z.object({
  competencia: competenciaBalanco,
  file_name: z.string().trim().min(1).max(255),
  meta: z.object({
    empresa: z.string().trim().max(255),
    periodo: z.string().trim().max(255),
    emissao: z.string().trim().max(64),
    grau: z.string().trim().max(64),
  }),
  contas: z.array(contaBalanco).min(3).max(20_000),
});

export type ContaBalanco = z.infer<typeof contaBalanco>;
export type SalvarBalancoRequest = z.infer<typeof salvarBalancoRequest>;

export interface BalancoResumo {
  id: number;
  competencia: string;
  empresa: string;
  periodo: string;
  file_name: string;
  total_contas: number;
  uploaded_by_name: string | null;
  updated_at: string;
}

export interface BalancoSalvo extends BalancoResumo {
  emissao: string;
  grau: string;
  contas: ContaBalanco[];
}

export interface SalvarBalancoResponse {
  balanco: BalancoSalvo;
  substituido: boolean;
}

/**
 * Documento contabil da competencia.
 *
 * DRE, balanco, nota explicativa e ata de registro sao reunidos num PDF unico
 * FORA do sistema e enviados assim. Por isso a tela tem um botao de download so:
 * nao ha o que escolher, e nao existe o estado "dois dos quatro chegaram".
 */
export const DOCUMENTO_MAX_BYTES = 25 * 1024 * 1024;

/** PDF apenas. Um .docx ou .xlsx aqui viraria um download que ninguem abre no celular. */
export const DOCUMENTO_MIME = 'application/pdf';

export const balancoDocumento = z.object({
  competencia: competenciaBalanco,
  file_name: z.string(),
  file_size: z.number().int().nonnegative(),
  uploaded_by_name: z.string().nullable(),
  uploaded_at: z.string(),
});
export type BalancoDocumento = z.infer<typeof balancoDocumento>;

/** `null` quando o administrador ainda nao publicou o documento do mes. */
export const balancoDocumentoResponse = z.object({
  documento: balancoDocumento.nullable(),
});
export type BalancoDocumentoResponse = z.infer<typeof balancoDocumentoResponse>;
